import { render, staticRenderFns } from "./tradeHistory.vue?vue&type=template&id=03df9019"
import script from "./tradeHistory.vue?vue&type=script&lang=js"
export * from "./tradeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports